import { type DefaultRootState } from 'react-redux';

export default function (state: DefaultRootState) {
  return state.spaceResource.filter.selected;
}
